import { FC } from "react";

import { Stack, SxProps } from "@mui/material";

import { FormDivider } from "@/forms-design-system/FormDivider";
import { FormTypography } from "@/forms-design-system/FormTypography";
import { useTranslate } from "@/hooks/useTranslate";

type PayAnotherWayDividerProps = {
  sx?: SxProps;
};

export const PayAnotherWayDivider: FC<PayAnotherWayDividerProps> = ({ sx }) => {
  const { t } = useTranslate();

  return (
    <Stack width="100%" direction="row" alignItems="center" gap={2} sx={sx}>
      <FormDivider sx={{ flexGrow: 1 }} />
      <FormTypography vibe="moderate" variant="subtitle2">
        {t("common", "payment.express.payAnotherWay")}
      </FormTypography>
      <FormDivider sx={{ flexGrow: 1 }} />
    </Stack>
  );
};
